import { FC, useState } from "react";
import Badge from "@cloudscape-design/components/badge";
import StatusIndicator from "@cloudscape-design/components/status-indicator";
import SpaceBetween from "@cloudscape-design/components/space-between";

interface ProfileHeaderProps {
    firstName: string;
    lastName: string;
    roleName: string;
    isActive: boolean;
    profilePictureUrl?: string;
}

const ProfileHeader: FC<ProfileHeaderProps> = ({
    firstName,
    lastName,
    roleName,
    isActive,
    profilePictureUrl,
}) => {
    const [imageError, setImageError] = useState(false);

    const initials = firstName[0].toUpperCase() + lastName[0].toUpperCase();

    const renderAvatar = () => {
        if (profilePictureUrl && !imageError) {
            return (
                <img
                    src={profilePictureUrl}
                    alt={`${firstName} ${lastName}`}
                    onError={() => setImageError(true)}
                    style={{
                        borderRadius: "50%",
                        width: 80,
                        height: 80,
                        objectFit: "cover",
                    }}
                />
            );
        }

        return (
            <div
                style={{
                    borderRadius: "50%",
                    width: 80,
                    height: 80,
                    backgroundColor: "#0972d3",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 32,
                    color: "#ffffff",
                    fontWeight: 600,
                }}
            >
                {initials}
            </div>
        );
    };

    return (
        <SpaceBetween direction="horizontal" size="l">
            {renderAvatar()}
            <SpaceBetween direction="vertical" size="xxs">
                <h2 style={{ margin: 0 }}>{`${firstName} ${lastName}`}</h2>
                <SpaceBetween direction="horizontal" size="xs">
                    <Badge>{roleName}</Badge>
                    <StatusIndicator type={isActive ? "success" : "stopped"}>
                        {isActive ? "Active" : "Inactive"}
                    </StatusIndicator>
                </SpaceBetween>
            </SpaceBetween>
        </SpaceBetween>
    );
};

export default ProfileHeader;
